// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"089a5ec8","830":"e5cf787e"}[chunkId] + ".chunk.js";
};